<template>
  <div class="preview_picture_w">
    <div v-if="hasRealisticImgs">


      <div class="main_w">
        <!-- 状态值 -->
        <div
          class="state_flag text_center c_fff fz12"
          :class="stateStyle(itemDetail.auctionState)"
        >
          {{ itemDetail.auctionStateDesc }}
        </div>
        <!-- 预览大图 -->
        <img
          :src="currentPreviewUrl + '!378'"
          alt=""
        >
        <!-- 视频，图片切换 -->
        <div v-if="projectInfo.videos && projectInfo.videos.length && projectInfo.realisticImgs.length" class="video_picture_check d_flex fz12 cursor_pointer">
          <span
            :class="checkVideo === 'picture' ? 'isCheck' : 'c_3084CF'"
            @click="checkVideo = 'picture'"
            >图片</span>
          <span
            :class="checkVideo === 'video' ? 'isCheck' : 'c_3084CF'"
            @click="checkVideo = 'video'"
            >视频</span>
        </div>

        <!-- 播放，暂停 -->
        <div v-if="checkVideo === 'video'" class="play_pause cursor_pointer">
          <img
            v-show="checkPlay === 'play'"
            src="@/assets/images/play.png"
            alt=""
            @click="onVideoPlayClick('pause')"
          >
          <img
            v-show="checkPlay === 'pause'"
            src="@/assets/images/pause.png"
            alt=""
            @click="onVideoPlayClick('play')"
          >
        </div>
        <!-- 播放器 -->
        <div
          v-show="playauth"
          id="J_prismPlayer"
          class="video_player"
        />
        <!-- 关闭播放器图标 -->
        <i v-show="playauth" class="close_video_icon el-icon-close c_fff fz24" @click="onClosePlayer" />
      </div>


      <div class="pic_list_w d_flex">
        <span
          class="switch_btn last_btn d_flex align_item_c justify_content_c bc_EBEBEB"
          @click="onPreviewLast"
          ><img
src="@/assets/images/lt.png"
alt=""
></span>
        <div class="pic_i d_flex justify_content_start">
          <img
            v-for="(item, index) in realisticImgs_"
            :key="index"
            class="small_pic"
            :class="index === activeIndex ? 'active_preview' : ''"
            :src="item + '!378'"
            alt=""
            :style="{
              transform: `translateX(${index * previewImgWidth}px)`,
              left: `${index * 10}px`,
            }"
            @click="onPreviewClick(item)"
          >
        </div>

        <span
          class="switch_btn next_btn d_flex align_item_c justify_content_c bc_EBEBEB"
          @click="onPreviewNext"
          ><img
src="@/assets/images/gt.png"
alt=""
></span>
      </div>
    </div>

    <div v-else class="default_pic_w">
      <div
        class="state_flag text_center c_fff fz12"
        :class="stateStyle(itemDetail.auctionState)"
      >
        {{ itemDetail.auctionStateDesc }}
      </div>
      <img src="@/assets/images/default_1.jpg" alt="">
    </div>

    <div class="d_flex justify_content_sb">
      <div
        v-for="(item, index) in previewOptions"
        :key="item.title"
        class="fz12 c_ccc"
        :class="item.disabled ? 'pre_i_disable' : 'pre_i_allow'"
        @click="onPreIconClick(item, index)"
      >
        <div class="pre_i d_flex align_item_c">
          <img :src="!item.disabled ? item.active_icon : item.icon" alt="">
          <span>{{ item.title }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { user_playAuth } from '@/api/user'
import { createPlayer } from '@/utils'
export default {
  props: {
    itemDetail: {
      type: Object,
      default: () => null
    }

  },
  data() {
    return {
      currentPreviewIndex: 0,
      previewImgWidth: 106,
      activeIndex: 0,
      currentPreviewUrl: '',

      previewOptions: [
        {
          icon: require('@/assets/images/g_icon_1.png'),
          title: '全景',
          active_icon: require('@/assets/images/g_icon_5.png'),
          disabled: true,
          type: 'vr'
        },
        {
          icon: require('@/assets/images/g_icon_2.png'),
          title: '视频',
          active_icon: require('@/assets/images/g_icon_6.png'),
          disabled: true,
          type: 'video'
        },
        {
          icon: require('@/assets/images/g_icon_3.png'),
          title: '地图',
          active_icon: require('@/assets/images/g_icon_7.png'),
          disabled: false,
          type: 'map'
        },
        {
          icon: require('@/assets/images/g_icon_4.png'),
          title: '分享',
          active_icon: require('@/assets/images/g_icon_8.png'),
          disabled: true,
          type: 'share'
        }
      ],
      preIconIndex: -1,
      optionsMap: new Map(),

      hasTargetLocation: false,

      checkVideo: 'picture',
      checkPlay: 'play',

      realisticImgs_: [],
      playauth: '', // 播放凭证

      initComplete: false
    }
  },
  computed: {
    projectInfo() {
      return this.itemDetail?.project || this.itemDetail
    },

    // 是否有预览图
    hasRealisticImgs: function() {
      return !!this.realisticImgs_?.length
    },
    // 项目状态颜色
    stateStyle: function() {
      return function(stateCode) {
        switch (stateCode) {
          case 0:
          case 1:
            return 'bc_22D179'
          case 3:
            return 'bc_EF3946'
          case 2:
          case 4:
          case 5:
            return 'bc_808080'
        }
      }
    }

  },
  watch: {
    checkVideo(n, o) {
      if (n === 'video') {
        this.realisticImgs_ = this.projectInfo.videos.map((i) => i.cover)
      } else {
        this.realisticImgs_ = this.projectInfo.realisticImgs
      }
      this.currentPreviewIndex = 0

      this.setPreviewUrl()
    },
    async checkPlay(n, o) {
      // 该标识仅表示图标
      if (n === 'pause') {
        const index = this.projectInfo.videos.findIndex((i) => i.cover === this.currentPreviewUrl)

        await this.getPlayAuth(this.projectInfo.videos[index])
        await this.initPlayer(this.projectInfo.videos[index])
      }
    },
    currentPreviewIndex(n, o) {
      this.onClosePlayer()
    },
    activeIndex(n, o) {
      this.onClosePlayer()
    }
  },
  created() {
    console.log('itemDetail', this.itemDetail)
    for (const v of this.previewOptions) {
      this.optionsMap.set(v.type, v)
    }

    // 预览图优先取图片，再到视频
    if (this.projectInfo.realisticImgs.length) {
      this.currentPreviewUrl = this.projectInfo.realisticImgs[0]
      this.realisticImgs_ = this.projectInfo.realisticImgs
    } else if (this.projectInfo.videos.length) {
      this.checkVideo = 'video'
      this.realisticImgs_ = this.projectInfo.videos.map((i) => i.cover)
    }
  },
  mounted() {
    if (this.projectInfo.targets) {
      for (const v of this.projectInfo.targets) {
        if ((v.gpsLat && v.gpsLng) || JSON.parse(v.layer)?.length) {
          this.hasTargetLocation = true
          break
        }
      }
    }

    this.optionsMap.get('map').disabled = !this.hasTargetLocation
    this.optionsMap.get('video').disabled = !this.projectInfo.videos?.length
    this.optionsMap.get('vr').disabled = !this.projectInfo.vrUrl

    this.initComplete = true
  },
  methods: {
    // 视频播放，暂停按钮 click
    onVideoPlayClick(type) {
      this.checkPlay = type
    },
    // 获取播放凭证
    async getPlayAuth(video) {
      const { data } = await user_playAuth({ videoId: video.videoId })
      this.playauth = data
    },
    // 初始播放器
    async initPlayer(video) {
      this.player = createPlayer(video, {
        id: 'J_prismPlayer',
        playauth: this.playauth,
        height: '240px'
      })
    },
    // 关闭播放器
    onClosePlayer() {
      try {
        this.playauth = ''
        this.player?.dispose() // 销毁之前的播放器
        this.checkPlay = 'play'
      } catch (err) {
        console.log()
      }
    },

    // 上一张 click
    onPreviewLast() {
      this.currentPreviewIndex--

      if (this.currentPreviewIndex < 0) {
        this.currentPreviewIndex = this.realisticImgs_.length - 1
      }
      this.realisticImgs_.unshift(
        this.realisticImgs_[this.realisticImgs_.length - 1]
      )
      this.realisticImgs_.pop()

      this.currentPreviewUrl = this.realisticImgs_[this.activeIndex]

      this.setPreviewUrl()
    },
    // 下一张 click
    onPreviewNext() {
      this.currentPreviewIndex++

      if (this.currentPreviewIndex > this.realisticImgs_.length - 1) {
        this.currentPreviewIndex = 0
      }
      this.realisticImgs_.push(this.realisticImgs_[0])
      this.realisticImgs_.shift()

      this.setPreviewUrl()
    },
    // 预览图 click
    onPreviewClick(url) {
      const activeIndex = this.realisticImgs_.findIndex((i) => i === url)
      this.currentPreviewUrl = this.realisticImgs_[activeIndex]
      this.setActiveIndex(activeIndex)
    },
    // 设置预览图url
    setPreviewUrl() {
      this.currentPreviewUrl = this.realisticImgs_[this.activeIndex]
    },
    // 设置预览index
    setActiveIndex(index) {
      this.activeIndex = index
    },

    // 预览按钮 click
    onPreIconClick(item, index) {
      if (item.disabled) return
      this.preIconIndex = index
      switch (item.type) {
        case 'map':
          this.handleMapPreIcon()
          break
        case 'video':
          let el = document.querySelector('#thirdTab')
          window.scrollTo(0, el.offsetTop - 44)
          break
        case 'vr':
          window.open(this.projectInfo.vrUrl)
      }
    },
    // 处理预览地图事件
    handleMapPreIcon() {
      if (this.hasTargetLocation) {
        let el = document.querySelector('#fifthTab')
        window.scrollTo(0, el.offsetTop - 44)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.bc_22D179 {
  background-color: rgba($color: #22d179, $alpha: 1);
}
.bc_2caeff {
  background-color: rgba($color: #2caeff, $alpha: 1);
}
.bc_8733CD {
  background-color: rgba($color: #8733cd, $alpha: 1);
}
.bc_FF9C00 {
  background-color: rgba($color: #ff9c00, $alpha: 1);
}
.bc_FC00FF {
  background-color: rgba($color: #fc00ff, $alpha: 1);
}

.bc_EF3946 {
  background-color: rgba($color: #ef3946, $alpha: 1);
}
.preview_picture_w {
  width: 380px;
  .pre_i {
    height: 30px;
    padding: 0 19px;
    border: 1px solid;
    & > span {
      margin: 0 0 0 4px;
    }
  }
  .pre_i_active {
    // color: #0983cc;
    // border-color: #0983cc;
  }
  .pre_i_disable {
    // opacity: 0.4;
    color: #ccc;
    border-color: #ccc;
    cursor: no-drop;
  }
  .pre_i_allow {
    color: #0983cc;
    border-color: #0983cc;
    cursor: pointer;
  }
  .main_w,
  .default_pic_w {
    overflow: hidden;
    position: relative;
    border: 1px solid #e6e6e6;
    margin: 0 0 10px 0;
    .state_flag {
      position: absolute;
      top: 0;
      left: 0;
      width: 100px;
      height: 100px;
      line-height: 170px;
      transform: translate(-50px, -50px) rotateZ(-45deg);
    }
  }
  .video_picture_check {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    padding: 1px;
    background-color: #fff;
    & > span {
      padding: 4px 16px;
      background-color: #fff;
      transition: all 0.2s;
    }
    .isCheck {
      color: #fff;
      background-color: #3084cf;
    }
  }
  .play_pause {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .main_w {
    height: 241px;

    &:hover {
        .close_video_icon {
          position: absolute;
          top: 0;
          right: 0;
          cursor: pointer;
          margin: 5px;
        }
      }
    & > img {
      display: block;
      width: 100%;
      height: 100%;
    }
    .video_player {
      position: absolute;
      top: 0;
      left: 0;

    }
  }
  .default_pic_w {
    & > img {
      display: block;
      width: 380px;
      height: 308px;
    }
  }
  .pic_list_w {
    overflow: hidden;
    height: 57px;
    margin: 10px 0;
  }
  .switch_btn {
    position: static;
    width: 20px;
    height: 100%;
    cursor: pointer;
    z-index: 1;
  }
  .last_btn {
    margin: 0 5px 0 0;
  }
  .pic_i {
    position: relative;
    width: 470px;
    transition: all 1s;
    &::-webkit-scrollbar {
      display: none;
    }
    & {
      scrollbar-width: none; //火狐
    }
  }
  .small_pic {
    position: absolute;
    top: 0;
    left: 0;
    width: 110px;
    height: 100%;
    padding: 2px;
    box-sizing: border-box;
    cursor: pointer;
    &:last-child {
      margin: 0;
    }
  }
  .active_preview {
    border: 2px solid #2caeff;
    padding: 0 !important;
  }
  .next_btn {
    margin: 0 0 0 5px;
  }
}
</style>
